module.exports = __webpack_public_path__ + "img/secondary_1x3_z16.9085c729.svg";